import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as PropTypes from 'prop-types';
import GroupTable from './GroupTable';
import { headerStyles } from './styles/GroupDirectory.css';
import { Button } from '@lwt-helix/buttons';
import { ButtonTypes, SortOrder } from '../../../constants/Enums';
import Routes from '../../../constants/Routes';
import { deleteSecurityGroup, fetchSecurityGroups } from '../../../api/SecurityGroupApi';
import { resetOperationStatus } from '../../../actions/SecurityGroupActions';
import LoadingOverlay from '../../LoadingOverlay/LoadingOverlay';
import { overlayDivStyles } from '../../common/styles/LoadingOverlay.css';
import PaginationItem from '../../common/PaginationItem';
import { Alert, AlertTypes } from './../../common/Alert';
import { AlertSizes } from '../../common/Alert';
import { fetchUsers } from '../../../api/AuthenticationApi';
import { getUsersForTable } from '../create/SecurityGroupFunctions';

class GroupDirectory extends Component {
    constructor(props) {
        super(props);

        this.state = {
            rows: [],
            visibleRows: [],
            activePage: 1,
            pageCount: 1,
            rowsPerPage: 5,
            headers: [
                {
                    'title': 'Security Group Name',
                    'target': 'name'
                },
                {
                    'title': 'Users',
                    'target': 'users'
                },
            ],
            isLoading: true,
            isAlertActive: false
        };
    }

    deleteSecurityGroup = (id) => {
        let securityGroupIndex = this.props.securityGroups.findIndex((p) => p.id === id);
        if (securityGroupIndex > -1) {
            let securityGroup = this.props.securityGroups[securityGroupIndex];
            if (securityGroup.users && securityGroup.users.length > 0) {
                this.setAlertActive(true);
                return;
            }
            if (window.confirm('Are you sure you want to delete this?')) {
                this.props.deleteSecurityGroup(id);
            }
        }
    };

    setAlertActive = (isActive) => {
        this.setState({ isAlertActive: isActive });
    };

    copySecurityGroup = (id) => {
        this.props.history.push(`/security-groups/copy/${id}`)
    };

    sort = (target, order) => {
        let rows = this.state.rows;
        if (order === SortOrder.ASCENDING) {
            rows.sort((a, b) => {
                if (target === 'name') {
                    return a[target].localeCompare(b[target]);
                }
                else {
                    return a[target] - b[target];
                }
            });
        }
        else {
            rows.sort((a, b) => {
                if (target === 'name') {
                    return b[target].localeCompare(a[target]);
                }
                else {
                    return b[target] - a[target];
                }
            });
        }
        this.updateVisibleRows(rows);
    };

    setRows = (securityGroups, authenticationUsers) => {
        let rows = securityGroups.map((securityGroup) => {
            let users = getUsersForTable(securityGroup.users, authenticationUsers);
            return ({
                name: securityGroup.name,
                description: securityGroup.description,
                users: (users?.length ?? 0),
                id: securityGroup.id,
                roleType: securityGroup.roleType
            });
        });
        this.updateVisibleRows(rows);
    };

    updateVisibleRows = (rows) => {
        let { activePage, rowsPerPage } = this.state;
        let startIndex = rowsPerPage * (activePage - 1);
        if (startIndex >= rows.length && startIndex >= rowsPerPage) {
            activePage = Math.floor(rows.length / rowsPerPage) - 1;
            startIndex = activePage * rowsPerPage;
        }
        let endIndex = startIndex + rowsPerPage;
        let visibleRows = rows.slice(startIndex, endIndex);
        let pageCount = Math.ceil(rows.length / rowsPerPage);
        this.setState({ rows, visibleRows, pageCount, activePage });
    };

    getPaginationItems = (pageCount) => {
        let paginationItems = [];

        paginationItems.push(
            <PaginationItem key={0} action={this.toggleVisibleRows}
                icon={'keyboard_arrow_left'}
                disabled={this.state.activePage === 1} pageValue={this.state.activePage - 1} />
        );
        for (let i = 1; i <= pageCount; i++) {
            paginationItems.push(
                <PaginationItem action={this.toggleVisibleRows} pageValue={i} text={i.toString()}
                    active={this.state.activePage === i} />
            )
        }

        paginationItems.push(
            <PaginationItem key={20} action={this.toggleVisibleRows}
                icon={'keyboard_arrow_right'}
                disabled={this.state.activePage === pageCount}
                pageValue={this.state.activePage + 1} />
        );

        return paginationItems;
    };

    toggleVisibleRows = (pageNum) => {
        if (!pageNum || pageNum > this.state.pageCount)
            return;
        let { rows, rowsPerPage } = this.state;
        let startIndex = (rowsPerPage * pageNum) - rowsPerPage;
        if (rows && rows.length >= startIndex) {
            let endIndex = rows.length >= startIndex + rowsPerPage
                ? startIndex + rowsPerPage
                : rows.length;
            let visibleRows = rows.slice(startIndex, endIndex);
            this.setState({ visibleRows, activePage: pageNum });
        }
    };

    UNSAFE_componentWillMount() {
        this.props.fetchSecurityGroups();
        this.props.fetchUsers();
        this.props.resetOperationStatus();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.securityGroups !== this.state.securityGroups) {
            this.setRows(nextProps.securityGroups, nextProps.users);
        }
        if (nextProps.isFetching !== this.state.isLoading) {
            this.setState({ isLoading: nextProps.isFetching });
        }
    }

    render() {
        const PaginationItems = this.getPaginationItems(this.state.pageCount);

        if (this.state.isLoading) {
            return (
                <div className={'content'} style={overlayDivStyles}>
                    <LoadingOverlay loading={true} />
                </div>
            );
        }
        else if (this.props.error && this.props.error.message) {
            return (
                <div className={'content text-center mt-5'}>
                    <h3>{this.props.error.message}</h3>
                </div>
            )
        }
        else {
            return (
                <>
                    <div className="container">
                        <div className="row mb-3">
                            <div className="col-sm-12">
                                <h3 className="float-left" style={headerStyles}>Security Groups</h3>
                                <Button
                                    dataLwtId="add-security-group"
                                    color="primary"
                                    className="float-right"
                                    type={ButtonTypes.PRIMARY}
                                    onClick={() => this.props.history.push(Routes.SECURITY_GROUP_CREATE)}
                                >
                                    Add Security Group
                                </Button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <GroupTable
                                    headers={this.state.headers}
                                    rows={this.state.visibleRows}
                                    sort={this.sort}
                                    deleteSecurityGroup={this.deleteSecurityGroup}
                                    copySecurityGroup={this.copySecurityGroup}
                                />
                                {this.state.visibleRows.length === 0 ? null :
                                    <div className={'row mt-2'}>
                                        <div className={'col-lg-3 offset-lg-9 col-6 offset-6'}>
                                            <nav>
                                                <ul className={'pagination justify-content-end'}>
                                                    {PaginationItems}
                                                </ul>
                                            </nav>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>

                    <Alert
                        onRequestClose={() => this.setAlertActive(false)}
                        content={'All users must be removed from security group before deletion'}
                        isOpen={this.state.isAlertActive}
                        size={AlertSizes.LARGE}
                        type={AlertTypes.INFO}
                        iconType={'info'}
                        heading={'INFO'}
                    />
                </>
            )
        }
    }
}

GroupDirectory.propTypes = {
    securityGroups: PropTypes.array,
    deleteSecurityGroup: PropTypes.func,
    history: PropTypes.object,
    fetchSecurityGroups: PropTypes.func,
    fetchUsers: PropTypes.func,
    resetOperationStatus: PropTypes.func,
    isFetching: PropTypes.bool,
    users: PropTypes.array,
    error: PropTypes.object
};

function mapStateToProps(state) {
    return {
        users: state.authenticationReducer.users,
        securityGroups: state.securityGroup.securityGroups,
        error: state.securityGroup.error,
        isFetching: state.securityGroup.isFetching,
        loggedIn: state.authenticationReducer.loggedIn,
        operationStatus: state.securityGroup.operationStatus
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ fetchSecurityGroups, deleteSecurityGroup, resetOperationStatus, fetchUsers }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(GroupDirectory));